import { Unit } from 'src/store/sageAdminApi';

export const NoneOption: 'NONE' = 'NONE';

export const CareTypes = {
    AssistedLiving: 'ASSISTED_LIVING',
    IndependentLiving: 'INDEPENDENT_LIVING',
    MemoryCare: 'MEMORY_CARE',
    LongTermCare: 'LONG_TERM_CARE',
    ShortTermRehab: 'SHORT_TERM_REHAB',
    SkilledNursing: 'SKILLED_NURSING',
} as const;

export type CareType = (typeof CareTypes)[keyof typeof CareTypes] | typeof NoneOption;

export const CareTypeLabels: Record<CareType | string, string> = {
    [CareTypes.AssistedLiving]: 'Assisted Living',
    [CareTypes.IndependentLiving]: 'Independent Living',
    [CareTypes.MemoryCare]: 'Memory Care',
    [CareTypes.LongTermCare]: 'Long Term Care',
    [CareTypes.ShortTermRehab]: 'Short Term Rehab',
    [CareTypes.SkilledNursing]: 'Skilled Nursing',
    [NoneOption]: 'None',
};

export const CareTypeLabelsAbbreviated: Record<CareType | string, string> = {
    [CareTypes.AssistedLiving]: 'AL',
    [CareTypes.IndependentLiving]: 'IL',
    [CareTypes.MemoryCare]: 'MC',
    [CareTypes.LongTermCare]: 'LTC',
    [CareTypes.ShortTermRehab]: 'STR',
    [CareTypes.SkilledNursing]: 'SN',
    [NoneOption]: 'None',
};

export const isSkilledNursingUnit = (unit?: Unit): boolean => {
    if (!unit) {
        return false;
    }

    // First, check careType
    if (unit.careType) {
        return isSkilledNursingCareType(unit.careType);
    }

    // If careType is undefined, check ward
    if (unit.ward) {
        return isSkilledNursingCareType(unit.ward);
    }

    // If neither careType nor ward is defined, return false
    return false;
};

export const isSkilledNursingCareType = (type: CareType | string): boolean => {
    return (
        type === CareTypes.LongTermCare ||
        type === CareTypes.ShortTermRehab ||
        type === CareTypes.SkilledNursing
    );
};

/**
 * (2022-12-07) Note: currently, wards use the same types as CareTypes,
 * but this will change in the future once we allow for facilities
 * to customize their own care types.
 */
export const WardLabels = CareTypeLabels;
